<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Fee List
                    </div>
                    <div class="card-body">
                        <div class="row search-form">
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_batch" class="form-control" placeholder="Search by Batch Code, Batch Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_fee" class="form-control" placeholder="Search by Fee Code, Fee Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <select v-model="filter.status" class="form-control">
                                    <option value="">Select Status</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_from" class="form-control" placeholder="From Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_to" class="form-control" placeholder="To Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in columns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sort_by === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(data, index) in dataList">
                                            <tr :key="'fee-' + data.id">
                                                <td style="cursor: pointer;" @click="togglePaymentTerms(data)" class="batch-name-cell">
                                                    <i :class="expandedRows.includes(data.id) ? 'fas fa-minus' : 'fas fa-plus'" style="margin-right: 8px;"></i>{{ data.batch.code1 }}{{ data.batch.code2 }}{{ data.batch.code3 }}</td>
                                                <td>                                                    {{ data.batch.name }}
                                                </td>
                                                <td>{{ data.code }}</td>
                                                <td>{{ data.name }}</td>
                                                <td>{{ data.amount.formatted }}</td>
                                                <td>
                                                    <span v-if="data.is_active" class="badge badge-success">Active</span>
                                                    <span v-else class="badge badge-danger">Inactive</span>
                                                </td>
                                                <td>
                                                    <button v-b-modal.bv-modal-editfee class="btn btn-option text-primary" @click="editFeeData(data)"><i class="fas fa-eye"></i></button>
                                                    <!-- <button v-b-modal.bv-modal-newpayment class="btn btn-option text-primary" @click="newPayment(data)"><i class="fas fa-plus"></i></button> -->
                                                    <!-- <button v-b-modal.bv-modal-delete class="btn btn-option text-danger" @click="deleteData(data)"><i class="fas fa-trash-alt"></i></button> -->
                                                </td>
                                            </tr>
                                            <!-- Payment Terms Row -->
                                            <tr v-if="expandedRows.includes(data.id)" :key="'terms-' + data.id" class="payment-terms-row">
                                                <td :colspan="Object.keys(columns).length + 1" class="payment-terms-container">
                                                    <div v-if="paymentTerms[data.id] && paymentTerms[data.id].length > 0" class="payment-terms-list">
                                                        <!-- <button v-b-modal.bv-modal-newpayment class="btn custom-btn text-primary" @click="newPayment(data)"><i class="fas fa-plus"></i> Create Payment Term</button> -->
                                                        <div class="table-responsive mt-3">
                                                            <table class="table table-sm table-bordered">
                                                                <thead class="thead-light">
                                                                    <tr>
                                                                        <th>Term Name</th>
                                                                        <th>Payment Term</th>
                                                                        <th>Duration Days</th>
                                                                        <th>Status</th>
                                                                        <th>Term Details</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="term in paymentTerms[data.id]" :key="term.id">
                                                                        <td>{{ term.name }}</td>
                                                                        <td>{{ term.payment_type ? term.payment_type.name : 'N/A' }}</td>
                                                                        <td>{{ term.duration_days }} days</td>
                                                                        <td>
                                                                            <span v-if="term.is_active" class="badge badge-success">Active</span>
                                                                            <span v-else class="badge badge-danger">Inactive</span>
                                                                        </td>
                                                                        <td>
                                                                        <button v-b-modal.bv-modal-editpayment class="btn btn-option text-primary" @click="editPayment(term)"><i class="fas fa-eye"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="paymentTerms[data.id] && paymentTerms[data.id].length === 0" class="text-center p-3">
                                                        <!-- <button v-b-modal.bv-modal-newpayment class="btn custom-btn text-primary" @click="newPayment(data)"><i class="fas fa-plus"></i> Create Payment Term</button> -->
                                                    </div>
                                                    <div v-else class="text-center p-3">
                                                        <!-- <button v-b-modal.bv-modal-newpayment class="btn custom-btn text-primary" @click="newPayment(data)"><i class="fas fa-plus"></i> Create Payment Term</button> -->
                                                    </div>
                                                </td>
                                            </tr>
                                    </template>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-pagination-minimal">
                            <div class="table-pagination-row">
                                <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                    Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                </div>
                                <!-- <nav class="pagination-minimal">
                                    <ul>
                                        <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                            <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                <i class="fas fa-angle-left"></i>
                                            </button>
                                        </li>
                                        <li v-for="page in metaData.last_page" :key="page"
                                            :class="{ 'active':metaData.current_page === page }"
                                            v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                            <button @click.prevent="next(page)">{{ page }}</button>
                                        </li>
                                        <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                            <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                <i class="fas fa-angle-right"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav> -->
                            </div>
                        </div>
                        <b-modal id="bv-modal-newpayment" ref="my-modal" title="New Payment" hide-footer size="md">
                            <template>
                                <div class="form-group">
                                    <label for="inputCode">Fee Code</label>
                                    <input type="text" v-model="info_fee_code" id="inputCode" class="form-control" disabled>
                                </div>
                                <div class="form-group">
                                    <label for="inputCode">Fee</label>
                                    <input type="text" v-model="info_fee_amount" id="inputCode" class="form-control" disabled>
                                </div>
                                <div class="form-group">
                                    <label for="inputCode">Payment Term</label>
                                    <select v-model="code" id="inputCode" class="form-control">
                                        <option value="">Select Times</option>
                                        <option v-for="time in times" :key="time.id" :value="time.code">{{ time.code }}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="inputName">Name</label>
                                    <input type="text" v-model="payment_name" id="inputName" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="inputDuration">Duration</label>
                                    <input type="number" v-model="payment_duration" id="inputDuration" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="inputDescription">Description</label>
                                    <textarea v-model="description" id="inputDescription" class="form-control"></textarea>
                                </div>
                                <div class="form-group" style="margin-left: 20px;">
                                    <input class="form-check-input" type="checkbox" id="activeCheckbox" v-model="active">
                                    <label class="form-check-label" for="activeCheckbox">
                                        Active
                                    </label>
                                </div>
                                <!-- Dynamic input fields based on selected payment type -->
                                <div v-if="getSelectedTimeValue() > 0">
                                    <div v-for="n in getSelectedTimeValue()" :key="n" class="form-group">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label :for="'inputPayment' + n">Payment {{ n }} Amount</label>
                                                <input 
                                                    type="number" 
                                                    :id="'inputPayment' + n"
                                                    v-model="paymentAmounts[n-1]"
                                                    class="form-control"
                                                    :placeholder="'Enter amount for payment ' + n"
                                                >
                                            </div>
                                            <div class="col-md-6">
                                                <label :for="'inputDuration' + n">Duration {{ n }} (Days)</label>
                                                <input 
                                                    type="number" 
                                                    :id="'inputDuration' + n"
                                                    v-model="paymentDurations[n-1]"
                                                    class="form-control"
                                                    :placeholder="'Enter days for payment ' + n"
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                     
                                <b-button class="mt-3 btn-success" block @click="submitPayment()">Submit</b-button>
                            </template>
                        </b-modal>
                        <b-modal id="bv-modal-fee" ref="my-modal" title="New Fee" hide-footer size="md">
                            <template>
                                <div class="form-group">
                                    <label for="inputCode">Fee Code</label>
                                    <input type="text" v-model="code" id="inputCode" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="inputName">Fee Name</label>
                                    <input type="text" v-model="name" id="inputName" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="inputAmount">Amount</label>
                                    <input type="number" v-model="amount" id="inputAmount" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="inputDescription">Description</label>
                                    <textarea v-model="description" id="inputDescription" class="form-control"></textarea>
                                </div>
                                <div class="form-group" style="margin-left: 20px;">
                                    <input class="form-check-input" type="checkbox" id="activeCheckbox" v-model="active">
                                    <label class="form-check-label" for="activeCheckbox">
                                        Active
                                    </label>
                                </div>
                                <!-- <b-button class="mt-3 btn-success" block @click="submitFee()">Submit</b-button> -->
                            </template>
                        </b-modal>
                        <b-modal id="bv-modal-editfee" ref="my-modal" title="Edit Fee" hide-footer size="md">
                            <template>
                                <div class="form-group">
                                    <label for="inputCode">Fee Code</label>
                                    <input type="text" v-model="code" id="inputCode" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="inputName">Fee Name</label>
                                    <input type="text" v-model="name" id="inputName" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="inputAmount">Amount</label>
                                    <input type="number" v-model="amount" id="inputAmount" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="inputDescription">Description</label>
                                    <textarea v-model="description" id="inputDescription" class="form-control"></textarea>
                                </div>
                                <div class="form-group" style="margin-left: 20px;">
                                    <input class="form-check-input" type="checkbox" id="activeCheckbox" v-model="active">
                                    <label class="form-check-label" for="activeCheckbox">
                                        Active
                                    </label>
                                </div>
                                <!-- <b-button class="mt-3 btn-success" block @click="submitEditFee()">Submit</b-button> -->
                            </template>
                        </b-modal>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        <b-modal id="bv-modal-editpayment" ref="my-modal" title="Edit Payment Term" hide-footer size="md">
                            <template>
                                <div class="form-group">
                                    <label for="editPaymentName">Payment Name</label>
                                    <input type="text" v-model="payment_name" id="editPaymentName" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="editPaymentDuration">Duration (Days)</label>
                                    <input type="number" v-model="payment_duration" id="editPaymentDuration" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="editPaymentDescription">Description</label>
                                    <textarea v-model="payment_description" id="editPaymentDescription" class="form-control"></textarea>
                                </div>
                                <div class="form-group" style="margin-left: 20px;">
                                    <input class="form-check-input" type="checkbox" id="editActiveCheckbox" v-model="active">
                                    <label class="form-check-label" for="editActiveCheckbox">
                                        Active
                                    </label>
                                </div>
                                
                                <!-- Edit Payment Term Times -->
                                <div v-if="editPaymentTermTimes.length > 0">
                                    <h6>Payment Term Details</h6>
                                    <div v-for="(termTime, index) in editPaymentTermTimes" :key="index" class="form-group">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <label>Payment {{ termTime.sort_order }} Amount</label>
                                                <input 
                                                    type="number" 
                                                    v-model="termTime.amount"
                                                    class="form-control"
                                                    placeholder="Enter amount"
                                                >
                                            </div>
                                            <div class="col-md-6">
                                                <label>Due Date {{ termTime.sort_order }}</label>
                                                <input 
                                                    type="date" 
                                                    v-model="termTime.duration_days"
                                                    class="form-control"
                                                    placeholder="Enter Date"
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                     
                                <!-- <b-button class="mt-3 btn-success" block @click="updatePayment()">Update Payment</b-button> -->
                            </template>
                        </b-modal>
                        <!-- <a class="float" href="#" v-b-modal.bv-modal-fee @click="newFee()">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </a> -->
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'feeList',
        metaInfo: {
            title: "Fee List",
            titleTemplate: "%s ← MIC",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                info_fee_code: '',
                info_fee_amount: '',
                batch_id: '',
                fee_id: '',
                payment_term_id: '',
                code: '',
                name: '',
                amount: '',
                description: '',
                active: true,
                payment_name: '',
                payment_duration: '',
                paymentAmounts: [], // Array to store amounts for each payment
                paymentDurations: [], // Array to store duration days for each payment
                editPaymentTermTimes: [],
                dataList: [],
                expandedRows: [], // Track which rows are expanded
                paymentTerms: {}, // Store payment terms for each fee
                permissions: '',
                times: [
                    { id: 1, value: 1, code: 'One Times' },
                    { id: 2, value: 2, code: 'Two Times' },
                    { id: 3, value: 3, code: 'Three Times' },
                    { id: 4, value: 4, code: 'Four Times' },
                    { id: 5, value: 5, code: 'Five Times' },
                ],
                columns: {
                    batch_code: "Batch Code",
                    batch_name: "Batch Name",
                    code: "Fee Code",
                    name: "Fee Name",
                    amount: "Fee",
                    is_active: "Active",
                },
                filter: {
                    page: 1,
                    per_page: 20,
                    sort_direction: "asc",
                    sort_by: "created_at",
                    limit: 10,
                    search_batch: '',
                    search_fee: '',
                    status: '',
                    date_from: '',
                    date_to: ''
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
            '$route' (to, from) {
                this.fetchData()
            },
            code(newVal) {
                // Reset payment amounts and durations when payment type changes
                this.paymentAmounts = [];
                this.paymentDurations = [];
            }
        },
        computed: {},
        methods: {
            ...mapActions({
                feeListAction: 'feeListAction',
                feeStoreAction: 'feeStoreAction',
                feeUpdateAction: 'feeUpdateAction',
                paymentStoreAction: 'paymentStoreAction',
                paymentUpdateAction: 'paymentUpdateAction',
                paymentTermsByFeeAction: 'paymentTermsByFeeAction',
                bankDeleteAction: 'bankDeleteAction',
            }),
            sortBy(column) {
                this.filter.sort_by = column
                if (this.filter.sort_by == column) {
                    if (this.filter.sort_direction == "asc") {
                        this.filter.sort_direction = "desc"
                    } else if (this.filter.sort_direction == "desc") {
                        this.filter.sort_direction = "asc"
                    }
                } else {
                    this.filter.sort_direction = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.feeListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.last_page
                        this.metaData.current_page = res.data.meta.current_page
                        this.metaData.prev_page_url = res.data.meta.prev_page_url
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            async submitFee() {
                this.isLoading = true
                const formData = new FormData();
                formData.append('batch_id', this.batch_id);
                formData.append('code', this.code);
                formData.append('name', this.name);
                formData.append('amount', this.amount);
                formData.append('description', this.description);
                formData.append('is_active', this.active ? 1 : 0);

                await this.feeStoreAction(
                    formData
                ).then(res => {
                    if(res.success === true) {
                        this.$refs['my-modal'].hide()
                        this.code = ''
                        this.name = ''
                        this.amount = ''
                        this.description = ''
                        this.active = true
                        this.fetchData()
                    } else {
                        this.alert = res.message
                    }
                    this.isLoading = false
                }).catch(err => this.isLoading = true)
            },
            async submitEditFee() {
                this.isLoading = true
                const formData = new FormData();
                formData.append('id', this.fee_id);
                formData.append('batch_id', this.batch_id);
                formData.append('code', this.code);
                formData.append('name', this.name);
                formData.append('amount', this.amount);
                formData.append('description', this.description);
                formData.append('is_active', this.active ? 1 : 0);

                await this.feeUpdateAction(
                    formData
                ).then(res => {
                    if(res.success === true) {
                        this.$refs['my-modal'].hide()
                        this.code = ''
                        this.name = ''
                        this.amount = ''
                        this.description = ''
                        this.active = true
                        this.fetchData()
                    } else {
                        this.alert = res.message
                    }
                    this.isLoading = false
                }).catch(err => this.isLoading = true)
            },
            async submitPayment() {
                this.isLoading = true
                
                // Get the selected payment type ID
                const selectedTime = this.times.find(time => time.code === this.code);
                const payment_type_id = selectedTime ? selectedTime.id : null;
                
                // Prepare payment term times array with amounts and durations
                const payment_term_times = [];
                for (let i = 0; i < this.getSelectedTimeValue(); i++) {
                    if (this.paymentAmounts[i] || this.paymentDurations[i]) {
                        payment_term_times.push({
                            sort_order: i + 1,
                            amount: this.paymentAmounts[i] || 0,
                            duration_days: this.paymentDurations[i] || 0
                        });
                    }
                }

                const formData = new FormData();
                formData.append('payment_type_id', payment_type_id);
                formData.append('fee_id', this.fee_id);
                formData.append('name', this.payment_name);
                formData.append('description', this.description);
                formData.append('duration_days', this.payment_duration);
                formData.append('is_active', this.active ? 1 : 0);
                formData.append('payment_term_times', JSON.stringify(payment_term_times));

                await this.paymentStoreAction(
                    formData
                ).then(res => {
                    if(res.success === true) {
                        this.$refs['my-modal'].hide()
                        this.code = ''
                        this.payment_name = ''
                        this.payment_duration = ''
                        this.description = ''
                        this.active = true
                        this.paymentAmounts = []
                        this.paymentDurations = []
                        this.fetchData()
                    } else {
                        this.alert = res.message
                    }
                    this.isLoading = false
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'fee-list', 
                    query: {
                        page: 1, 
                        per_page: 10,
                        sort_direction: 'desc', 
                        sort_by: 'created_at',
                        search: '',
                        date_from: '',
                        date_to: ''
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            newFee(){
                this.code = ''
                this.name = ''
                this.amount = ''
                this.description = ''
                this.active = true
                this.alert = ""
            },
            editFeeData(data){
                this.batch_id = data.batch.id
                this.fee_id = data.id
                this.code = data.code
                this.name = data.name
                this.amount = data.amount.value
                this.description = data.description
                this.active = data.is_active === true || data.is_active === 1 ? true : false
                this.alert = ""
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.bankDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            },
            getSelectedTimeValue() {
                const selectedTime = this.times.find(time => time.code === this.code);
                return selectedTime ? selectedTime.value : 0;
            },
            newPayment(data) {
                 this.info_fee_code = data.code;
                this.info_fee_amount = data.amount.value;
                this.fee_id = data.id;
                this.code = '';
                this.payment_name = '';
                this.payment_duration = '';
                this.description = '';
                this.active = true;
                this.paymentAmounts = [];
                this.paymentDurations = [];
                this.alert = "";
            },
            editPayment(data) {
                this.payment_term_id = data.id;
                this.payment_name = data.name;
                this.payment_duration = data.duration_days;
                this.payment_description = data.description;
                this.payment_active = data.is_active === true || data.is_active === 1 ? true : false;

                // Copy payment term times for editing
                this.editPaymentTermTimes = data.payment_term_times ? 
                    data.payment_term_times.map(term => ({
                        id: term.id,
                        sort_order: term.sort_order,
                        amount: term.amount,
                        duration_days: term.duration_days
                    })) : [];
                
                console.log('Editing payment:', data);
                this.alert = "";
            },
            async updatePayment() {
                this.isLoading = true;
                
                const formData = new FormData();
                formData.append('id', this.payment_term_id);
                formData.append('name', this.payment_name);
                formData.append('description', this.payment_description);
                formData.append('duration_days', this.payment_duration);
                formData.append('is_active', this.active ? 1 : 0);
                formData.append('payment_term_times', JSON.stringify(this.editPaymentTermTimes));
                
                try {
                    const response = await this.paymentUpdateAction(formData);
                    if (response.success) {
                        this.$refs['my-modal'].hide();
                        this.alert = "";
                        // Refresh the payment terms for this fee
                        this.paymentTerms = {};
                        this.expandedRows = [];
                    } else {
                        this.alert = response.message;
                    }
                } catch (error) {
                    console.error('Error updating payment:', error);
                    this.alert = "Failed to update payment";
                }
                
                this.isLoading = false;
            },
            async togglePaymentTerms(data) {
                const feeId = data.id;
                
                // Toggle row expansion
                if (this.expandedRows.includes(feeId)) {
                    // Collapse: remove from expanded rows and clear its data
                    this.expandedRows = this.expandedRows.filter(id => id !== feeId);
                    this.$delete(this.paymentTerms, feeId);
                } else {
                    // Expand: add to expanded rows and always fetch fresh data
                    this.expandedRows.push(feeId);
                    
                    // Always show loading state and fetch fresh data
                    this.$set(this.paymentTerms, feeId, null); // Show loading state
                    
                    try {
                        const response = await this.paymentTermsByFeeAction({ fee_id: feeId });
                        console.log('Payment terms response for fee', feeId, ':', response);
                        if (response.success) {
                            this.$set(this.paymentTerms, feeId, response.data);
                        } else {
                            this.$set(this.paymentTerms, feeId, []);
                        }
                    } catch (error) {
                        console.error('Error fetching payment terms:', error);
                        this.$set(this.paymentTerms, feeId, []);
                    }
                }
            }

        },
        mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.batch_id = this.$route.query.id
            this.filter.page = this.$route.query.page
            this.filter.per_page = this.$route.query.per_page
            this.filter.sort_by = this.$route.query.sort_by
            this.filter.sort_direction = this.$route.query.sort_direction
            this.filter.search_batch = this.$route.query.search_batch
            this.filter.search_fee = this.$route.query.search_fee
            this.filter.status = this.$route.query.status
            this.filter.date_from = this.$route.query.date_from
            this.filter.date_to = this.$route.query.date_to
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
.badge-16 {
    font-size: 16px;
}

/* Payment terms styling */
.batch-name-cell {
    color: #007bff;
    font-weight: 500;
    
    &:hover {
        background-color: #f8f9fa;
        color: #0056b3;
    }
}

.payment-terms-row {
    background-color: #f8f9fa;
}

.payment-terms-container {
    padding: 15px !important;
    border-left: 4px solid #007bff;
}

.payment-terms-list {
    h5 {
        color: #495057;
        margin-bottom: 15px;
        font-size: 1.1rem;
    }
    
    .table {
        margin-bottom: 0;
        
        th {
            background-color: #e9ecef;
            font-size: 0.875rem;
            font-weight: 600;
        }
        
        td {
            font-size: 0.875rem;
            vertical-align: middle;
        }
    }
}
</style>